
new bstackSlider({
  selector: ".bstack-testi-container",
  cssClass: [],
  showDots: true
});
